export const STAGE = {
  INITIAL: 'initial',
  DETAIL: 'detail',
  ERROR: 'error',
  EMPTY: 'empty',
}
